import Address from "../../../domain/fundamentals/address/Address";
import Office  from "../../../domain/office/Office";
import {
  ACTION_TYPE,
  OfficeAction,
  SetOfficeAction,
  SetOfficeAddressBuildingAction,
  SetOfficeAddressCityAction,
  SetOfficeAddressPostalCodeAction,
  SetOfficeAddressPrefectureAction,
  SetOfficeAddressStreetAction,
  SetOfficeEmailAction,
  SetOfficeNameAction,
  SetOfficeNameKanaAction
}              from "./OfficeAction";

const officeReducer = (state: Office = new Office(), action: OfficeAction): Office => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_OFFICE:
      return reduceOffice(action as SetOfficeAction);
    case ACTION_TYPE.SET_OFFICE_NAME:
      return reduceOfficeName(state, action as SetOfficeNameAction);
    case ACTION_TYPE.SET_OFFICE_NAME_KANA:
      return reduceOfficeNameKana(state, action as SetOfficeNameKanaAction);
    case ACTION_TYPE.SET_OFFICE_EMAIL:
      return reduceOfficeEmail(state, action as SetOfficeEmailAction);
    case ACTION_TYPE.SET_OFFICE_ADDRESS_POSTAL_CODE:
      return reduceOfficeAddressPostalCode(state, action as SetOfficeAddressPostalCodeAction);
    case ACTION_TYPE.SET_OFFICE_ADDRESS_PREFECTURE:
      return reduceOfficeAddressPrefecture(state, action as SetOfficeAddressPrefectureAction);
    case ACTION_TYPE.SET_OFFICE_ADDRESS_CITY:
      return reduceOfficeAddressCity(state, action as SetOfficeAddressCityAction);
    case ACTION_TYPE.SET_OFFICE_ADDRESS_STREET:
      return reduceOfficeAddressStreet(state, action as SetOfficeAddressStreetAction);
    case ACTION_TYPE.SET_OFFICE_ADDRESS_BUILDING:
      return reduceOfficeAddressBuilding(state, action as SetOfficeAddressBuildingAction);
  }
};

const reduceOffice = (action: SetOfficeAction): Office => {
  return action.office;
};

const reduceOfficeName = (state: Office, action: SetOfficeNameAction): Office => {
  return new Office(state.id, action.name, state.nameKana, state.email, state.address);
};

const reduceOfficeNameKana = (state: Office, action: SetOfficeNameKanaAction): Office => {
  return new Office(state.id, state.name, action.nameKana, state.email, state.address);
};

const reduceOfficeEmail = (state: Office, action: SetOfficeEmailAction) => {
  return new Office(state.id, state.name, state.nameKana, action.email, state.address);
};

const reduceOfficeAddressPostalCode = (state: Office, action: SetOfficeAddressPostalCodeAction): Office => {
  return new Office(state.id, state.name, state.nameKana, state.email, new Address(action.postalCode, state.address.prefecture, state.address.city, state.address.street, state.address.building));
};

const reduceOfficeAddressPrefecture = (state: Office, action: SetOfficeAddressPrefectureAction): Office => {
  return new Office(state.id, state.name, state.nameKana, state.email, new Address(state.address.postalCode, action.prefecture, state.address.city, state.address.street, state.address.building));
};

const reduceOfficeAddressCity = (state: Office, action: SetOfficeAddressCityAction): Office => {
  return new Office(state.id, state.name, state.nameKana, state.email, new Address(state.address.postalCode, state.address.prefecture, action.city, state.address.street, state.address.building));
};

const reduceOfficeAddressStreet = (state: Office, action: SetOfficeAddressStreetAction): Office => {
  return new Office(state.id, state.name, state.nameKana, state.email, new Address(state.address.postalCode, state.address.prefecture, state.address.city, action.street, state.address.building));
};

const reduceOfficeAddressBuilding = (state: Office, action: SetOfficeAddressBuildingAction): Office => {
  return new Office(state.id, state.name, state.nameKana, state.email, new Address(state.address.postalCode, state.address.prefecture, state.address.city, state.address.street, action.building));
};

export default officeReducer;